import { render, staticRenderFns } from "./AddTaskField.vue?vue&type=template&id=2e35b83c&scoped=true&"
import script from "./AddTaskField.vue?vue&type=script&lang=js&"
export * from "./AddTaskField.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskField.vue?vue&type=style&index=0&id=2e35b83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35b83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
